// 招待リンク受け取り画面 /join?token=xxx
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function JoinPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, joinByToken } = useAuth();
  const token = params.get('token');
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [familyName, setFamilyName] = useState('');

  useEffect(() => {
    (async () => {
      if (!token) {
        setStatus('error');
        return;
      }
      if (!user) {
        // 未ログインならLoginへ。loginリダイレクト後の戻り先としてtokenを保持
        sessionStorage.setItem('ktv_pending_invite', token);
        return;
      }
      const family = await joinByToken(token);
      if (family) {
        setFamilyName(family.name);
        setStatus('success');
        sessionStorage.removeItem('ktv_pending_invite');
        setTimeout(() => navigate('/'), 2000);
      } else {
        setStatus('error');
      }
    })();
  }, [token, user, joinByToken, navigate]);

  if (!token) {
    return (
      <div className="card">
        <h2>招待トークンがありません</h2>
        <p className="muted">URLが正しいか確認してください。</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="card">
        <h2>ログインが必要です</h2>
        <p className="muted">ログイン後、自動で家族に参加できます。</p>
        <button className="btn btn-primary" onClick={() => navigate('/')}>
          ログインする
        </button>
      </div>
    );
  }

  return (
    <div className="card" style={{ textAlign: 'center' }}>
      {status === 'loading' && <p className="muted">参加処理中...</p>}
      {status === 'success' && (
        <div>
          <h2>✅ 「{familyName}」に参加しました！</h2>
          <p className="muted">2秒後にホームに移動します...</p>
        </div>
      )}
      {status === 'error' && (
        <div>
          <h2>❌ 参加できませんでした</h2>
          <p className="muted">招待トークンが無効か、すでに参加済みです。</p>
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            ホームに戻る
          </button>
        </div>
      )}
    </div>
  );
}
